// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"HU-z","inlineTitle":"IU-z","sponsoredAdsWrapper":"JU-z","marketplaceRecosWrapper":"KU-z"};